module.exports = __webpack_public_path__ + "slightly_frowning_face.svg?cfc505cad75ab10395d859ce608482c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feelings2/slightly_frowning_face.svg
// module id = 88
// module chunks = 0